import { isLibrariesSubSideNavPathname } from '~/utils/isLibrariesSubSideNavPathname';
import { isSearchSubSideNavPathname } from '~/utils/isSearchSubSideNavPathname';
import { isSettingsSubSideNavPathname } from '~/utils/isSettingsSubSideNavPathname';

export const isSubSideNavPathname = (pathname: string) =>
  isSearchSubSideNavPathname(pathname) ||
  isLibrariesSubSideNavPathname(pathname) ||
  isSettingsSubSideNavPathname(pathname);
